import { Image, Menu } from "antd";
import React, { Component } from "react";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "universal-cookie";
import config from "../config";

class MastersMenu extends Component {
  constructor(props, context) {
    super(props);
    // console.log(props);
    this.cookies = new Cookies();

    this.state = {
      showMenu: false,
      showMenu1: true,
      activeMenu: null,
      items: [],
      remaining: [],
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu = () => {
    this.setState({ showMenu1: false });
  };

  handleMenuClick = (items) => {
    const clickedItem = this.findMenuItem(this.state.remaining, items.key);
    const label = clickedItem ? clickedItem.label : "";
    this.props.navigate("/" + items.key);
    this.props.updateTitle(label);
    this.props.closeMenu();
    // this.setState({ activeWindow: null });
  };

  findMenuItem = (menuItems, key) => {
    for (const item of menuItems) {
      if (item.key === key) return item;
      if (item.children) {
        const found = this.findMenuItem(item.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  async componentDidMount() {
    const rolePermission = JSON.parse(
      base64_decode(this.cookies.get("data"))
    ).rolePermission;

    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span
              className="menu-items-title"
              style={{ gap: 10 }}
              // style={{
              //   color: "#fff",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
            >
              <img
                src={require("../assets/images/NewDesign/box-fill.png")}
                alt="Masters"
                style={{ width: "22px" }}
              />
              {this.context.translate("_MASTERS_")}
            </span>

            {Number(config.showMenuDescription) !== 0 && (
              <p
                style={{
                  fontSize: "10px",
                  marginTop: "5px",
                  color: "rgba(255, 255, 255, 0.8)",

                  marginBottom: "0px",
                }}
              >
                {this.context.translate("_MASTERS_TITILE_")}
              </p>
            )}
          </div>
        ),
      },
    ];
    const remaining = [
      this.props.accountChildren.length > 0 && {
        key: "parentaccount",
        type: "parentaccount",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/person-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_")}
            </span>
            {/* {this.state.showMenu1 && ( */}
            <p
              className="submenu-items-desc"
              style={
                {
                  // fontSize: "10px",
                  // marginTop: "10px",
                  // color: "rgba(0, 0, 0, 0.8)",
                  // marginBottom: "0px",
                  // textWrap: "auto",
                  // lineHeight: "normal",
                }
              }
            >
              {Number(config.showMenuDescription) !== 0 &&
                this.context.translate("_ACCOUNT_TAB_TITILE_")}
            </p>
            {/* )} */}
          </div>
        ),
        children: this.props.accountChildren,
        // children2: [
        //   {
        //     key: "companyList",
        //     label: this.context.translate("_COMPANY_LIST_"),
        //     // onClick: () => this.props.navigate("/companyList"),
        //   },
        //   {
        //     key: "companyuserlist",
        //     label: this.context.translate("_FLEET_USER_USERLIST_TITLE_"),
        //   },
        //   {
        //     key: "companydriverslist",
        //     label: this.context.translate("_FLEET_DRIVER_DRIVERLIST_TITLE_"),
        //   },
        //   {
        //     key: "companystafflist",
        //     label: this.context.translate("_EMPLOYEE_"),
        //   },
        //   {
        //     key: "passengerList",
        //     label: this.context.translate("_PASSENGER_LIST_"),
        //   },
        //   {
        //     key: "taxiCustomers",
        //     label: this.context.translate("_TAXI_CUSTOMERS_"),
        //   },
        //   {
        //     key: "discountList",
        //     label: this.context.translate("_DISCOUNT_LIST_"),
        //   },
        //   {
        //     key: "advertisementList",
        //     label: this.context.translate("_ADVERTISEMENT_"),
        //   },
        //   {
        //     key: "audiomessage",
        //     label: this.context.translate("_AUDIO_MESSAGE_"),
        //   },
        //   {
        //     key: "poiList",
        //     label: this.context.translate("_POINT_OF_INTEREST_"),
        //   },
        //   {
        //     key: "eventList",
        //     label: this.context.translate("_EVENT_"),
        //   },
        //   {
        //     key: "newsList",
        //     label: this.context.translate("_NEWS_"),
        //   },
        //   {
        //     key: "specialOfferList",
        //     label: this.context.translate("_SPECIAL_OFFER_"),
        //   },
        // ],
      },
      this.props.vehicleManagement.length > 0 && {
        key: "vehiclemanagement",
        type: "vehiclemanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Subtract.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_VEHICLE_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_VEHICLE_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.vehicleManagement,
      },
      this.props.fuelManagement.length > 0 && {
        key: "parentfuelmanagement",
        type: "parentfuelmanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              className="submenu-items-title"
              style={{ gap: 10 }}
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Subtract-1.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FUEL_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_FUEL_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.fuelManagement,
      },
      this.props.schoolManagement.length > 0 && {
        key: "parentschoolmanagement",
        type: "parentschoolmanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Subtract-2.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_SCHOOL_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_SCHOOL_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.schoolManagement,
      },
      this.props.jobManagement.length > 0 && {
        key: "parentjobmanagement",
        type: "parentjobmanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/briefcase-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_JOB_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_JOB_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.jobManagement,
      },
      this.props.taxiManagement.length > 0 && {
        key: "parenttaximanagement",
        type: "parenttaximanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Union.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_TAXI_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_TAXI_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.taxiManagement,
      },
      this.props.tripmanagement.length > 0 && {
        key: "parenttripmanagement",
        type: "parenttripmanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Trip-management.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_TRIP_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_TRIP_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.tripmanagement,
      },
      this.props.payment?.length > 0 && {
        key: "parentpayment",
        type: "parentpayment",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap:10,
              //   margin: 0,
              //   fontSize: "16px",
              //   fontWeight: "500",
              // }}
              className="submenu-items-title"
              style={{ gap: 10 }}
            >
              <Image
                src={require("../assets/images/NewDesign/Masters/Payment.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_PAYMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_PAYMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.payment,
      },
      this.props.warehouseManagement?.length > 0 && {
        key: "parentwarehousemanagement",
        type: "parentwarehousemanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Masters/warehouse.png")}
                style={{ width: "14px" }}
              />
              {this.context.translate("_WAREHOUSE_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p className="submenu-items-desc">
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_WAREHOUSE_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.warehouseManagement,
      },
      this.props.inventoryManagement?.length > 0 && {
        key: "parentinventorymanagement",
        type: "parentinventorymanagement",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Masters/Inventory.png")}
                style={{ width: "14px" }}
              />
              {this.context.translate("_INVENTORY_MANAGEMENT_")}
            </span>
            {this.state.showMenu1 && (
              <p className="submenu-items-desc">
                {Number(config.showMenuDescription) !== 0 &&
                  this.context.translate("_INVENTORY_MANAGEMENT_TITILE_")}
              </p>
            )}
          </div>
        ),
        children: this.props.inventoryManagement,
      },
    ];

    this.setState({ items: items, remaining: remaining });
  }
  render() {
    return (
      <div
        className="menu-items-card"
        style={{
          width: Number(config.showMenuDescription) == 0 ? "300px" : "400px",
        }}
      >
        <div className="menu-items-list">
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            }}
            items={this.state.items}
            // onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
        <div
          className="submenu-items-list"
          style={
            {
              // overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              // height: "75%",
              // scrollbarWidth: "none",
            }
          }
        >
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              alignContent: "flex-start",
              height: "100%",
            }}
            mode="inline"
            items={this.state.remaining}
            // onOpenChange={this.onOpenChange}
            onClick={(items, label) => this.handleMenuClick(items, label)}
            onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
      </div>
    );
  }
}
MastersMenu.contextType = StoreContext;
export default observer(withRouter(MastersMenu));
